<template>
    <div v-html="recipeBoxForm"></div>
</template>

<script>
    import axios from 'axios';

    export default {
        mounted() {
            this.getForm();
        },
        props: {
            endpoint: {
                type: String,
                default: '/aha-service/RecipeBox/GetRecipeBoxes'
            },
            recipeId: {
                type: String,
                required: true
            },
            errorMessage: {
                type: String,
                default: 'Error loading Recipe Box Folder'
            }
        },
        data() {
            return {
                recipeBoxForm: null
            };
        },
        methods: {
            getForm() {
                axios({
                    method: 'post',
                    url: this.$props.endpoint, 
                    responseType: 'text',
                    data: {
                        recipeId: this.$props.recipeId
                    }
                })
                .then(response => {
                    this.recipeBoxForm = response.data;
                }).catch(error => {
                    this.recipeBoxForm = `
                        <div class="alert alert-danger" role="alert">
                            ${this.$props.errorMessage}
                        </div>
                    `;

                    // eslint-disable-next-link
                    console.log(error);
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/aha-add-to-recipe-box.vue